export default (err: Error) => err.message.substring(0, 500);
